import React, {useImperativeHandle, useState, forwardRef} from "react";

import {View, Text}  from 'react-native';

import {estilos} from '../util/estilos'

import Alerta from '../componentes/Alerta'
	
import {TAM_MAX_IMAGEM, DESCRICAO_TAM_MAX_IMAGEM} from '../util/constantes'

import * as util from '../util/util'


const Upload = forwardRef((props, ref) => {


	const [arquivo, setArquivo] = useState(null)
	
	
	useImperativeHandle(ref, () => ({
		getArquivo: () =>{return arquivo;}
	}));


	const handleFileChange = async (e) => {
		
		util.print("ok1");

		let arquivo = e.target.files[0];

		if (arquivo.size > TAM_MAX_IMAGEM) {
	
			Alerta("Atenção", 'O tamanho máximo da imagem é de '+DESCRICAO_TAM_MAX_IMAGEM+'MB.');
			return;
  		}

		setArquivo(arquivo);
		util.print("ok1b");

		if(props.acaoRecebimentoArquivo !=null)
			await props.acaoRecebimentoArquivo(arquivo);
	};


	return (
		<View style={{alignItems:'center'}}>
			<input type="file" accept="image/jpeg, image/png" onChange={handleFileChange} />
			<View style={{marginTop:20}}/>
			<Text style={estilos.rotulo_menor}>Formatos aceitos: jpeg, jpg ou png. Tamanho máximo {DESCRICAO_TAM_MAX_IMAGEM}MB.</Text>
		</View>
	)
});


export default Upload;
